// extracted by mini-css-extract-plugin
export default {"code":"order-promocode_code__nYsPW"};